var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4645 5.22306H9.97243C9.12202 5.22306 8.35799 5.59425 7.83548 6.18098C7.31297 5.59425 6.54894 5.22306 5.69853 5.22306C5.17973 5.22306 4.69336 5.36169 4.2739 5.60252V0.992188H0V17.9157H4.2739V15.0951H20.0398V17.9157H24.3137C24.3137 16.5722 24.3137 9.22062 24.3137 8.04364C24.3137 6.48837 23.0355 5.22306 21.4645 5.22306ZM2.84926 16.5054H1.42463V2.40248H2.84926C2.84926 6.80122 2.84926 12.1013 2.84926 16.5054ZM4.2739 8.04364C4.2739 7.26601 4.91299 6.63335 5.69853 6.63335C6.48407 6.63335 7.12316 7.26601 7.12316 8.04364V9.45393H4.2739V8.04364ZM22.8891 16.5054H21.4645V15.0951H22.8891V16.5054ZM22.8891 13.6848C22.0165 13.6848 5.254 13.6848 4.2739 13.6848V10.8642H22.8891V13.6848ZM22.8891 9.45393H8.54779V8.04364C8.54779 7.26601 9.18688 6.63335 9.97243 6.63335H21.4645C22.25 6.63335 22.8891 7.26601 22.8891 8.04364V9.45393Z",
    fill: "#00A851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.bd76820c78e98c0104a9ae7078cfcd2a.svg";
export { ForwardRef as ReactComponent };